function stripTrailingSlash(url) {
  return url.replace(/\/$/, "");
}

function isRemoteApiUrl(url) {
  return typeof url === "string" && /^https?:\/\//i.test(url) && !url.includes("localhost") && !url.includes("127.0.0.1");
}

/**
 * Resolve API base URL for browser vs build time.
 *
 * - Production: VITE_API_BASE_URL (Railway, etc.)
 * - Dev in browser: always /api → Vite proxy → local backend (works on desktop + phone)
 * - Dev in tests/node: direct URL fallback
 */
export function resolveApiBaseUrl() {
  const configured = import.meta.env.VITE_API_BASE_URL?.trim() || "";

  if (import.meta.env.PROD) {
    return stripTrailingSlash(configured || "http://localhost:4000");
  }

  if (typeof window !== "undefined") {
    return "/api";
  }

  if (configured && isRemoteApiUrl(configured)) {
    return stripTrailingSlash(configured);
  }

  return stripTrailingSlash(configured || "http://localhost:4000");
}
